import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { FaDownload, FaShare,FaShareAlt } from 'react-icons/fa';

const ProductCardOne = ({ subProd, onClick, onDownload, onShare }) => {
  const [aspectRatio, setAspectRatio] = useState("1 / 1");

  const handleImageLoad = (event) => {
    const { naturalWidth, naturalHeight } = event.target;
    setAspectRatio(`${naturalWidth} / ${naturalHeight}`);
  };

  return (
    <Card 
      className="h-100 shadow-sm border-0 rounded-4 overflow-hidden bg-white d-flex flex-column"
      style={{ cursor: 'pointer' }}
    >
      {/* Image Area with dynamic aspect ratio and no padding */}
      <div 
        className="w-100 bg-light position-relative overflow-hidden"
        style={{ aspectRatio: aspectRatio }}
        onClick={onClick}
      >
        <Card.Img 
          variant="top" 
          src={subProd.img} 
          alt={subProd.name}
          onLoad={handleImageLoad}
          className="w-100 h-100 object-fit-cover"
        />
      </div>

      {/* Body Content with name and bottom section */}
      <Card.Body className="p-0 d-flex flex-column justify-content-between flex-grow-1">
        {/* Product Title */}
        <Card.Title 
          className="fw-bold text-dark mb-3 text-truncate" 
          style={{ fontSize: '0.85rem' }}
          title={subProd.name}
          onClick={onClick}
        >
          {subProd.name}
        </Card.Title>

        {/* Bottom Action Bar matching the design */}
        <div 
          className="d-flex align-items-center 
          justify-content-between text-white px-3 py-2 
          rounded-0 mt-auto w-100"
          style={{ backgroundColor: '#1a1a1a' }}
        >
          <span 
            className="fw-semibold text-start text-nowrap" 
            style={{ fontSize: '0.85rem', cursor: 'pointer' }}
            onClick={onClick}
          >
            View &rarr;
          </span>
          <div className="d-flex align-items-center 
          justify-content-end gap-3" >
            <FaShareAlt size={14} 
                onClick={(e) => {
                    e.stopPropagation();
                    onShare(subProd);
                }}
            />
            <FaDownload size={14}
                onClick={(e) => {
                    e.stopPropagation();
                    onDownload(subProd);
                }}
            />
             
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ProductCardOne;